module.exports = __webpack_public_path__ + "static/media/pedido-realizado-gray.913ab57b.svg";